// Styles for Upgrade go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledUpgrade = styled.div`
  a {
    word-wrap: break-word;
  }
  ul {
    li {
      padding: 1rem;

      a {
        color: ${baseVariables.color.bvyAccent20};

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  a[title*='Marriott.com'] {
    text-decoration: underline;
  }
  .l-margin-none {
    margin: 0;
  }
  .t-uniform-height {
    margin-top: 1rem;
  }
`;
